import AddressFields from 'domains/user/organisms/user-create-form/address-fields'
import UserFields from 'domains/user/organisms/user-create-form/user-fields'
import { Form, Formik } from 'formik'
import { Card, Col, Row } from 'reactstrap'
import PropTypes from 'prop-types'
import { LoaderButton } from 'components/molecules'
import initialValues from 'domains/user/organisms/user-create-form/user-create-form-initial-values'
import { userCreateFormSchema } from 'domains/user/organisms/user-create-form/user-create-form-schema'
import SellerCreateFields from 'domains/user/organisms/user-create-form/seller-create-fields'
import SellerBankAccountFields from 'domains/user/organisms/user-create-form/seller-bank-account-fields'
import { TitlePage } from 'components/atoms'

const propTypes = {
  buttonText             : PropTypes.string.isRequired,
  handleSubmitForm       : PropTypes.func.isRequired,
  copyUserProfileOnClick : PropTypes.func.isRequired,
  handleAddressChange    : PropTypes.func.isRequired,
  isAddSeller            : PropTypes.bool.isRequired,
  handleAddSellerOnClick : PropTypes.func.isRequired,
  addSellerButtonText    : PropTypes.string.isRequired,
  user                   : PropTypes.object,
  user_address           : PropTypes.object,
  seller                 : PropTypes.object
}

const defaultProps = {
  buttonText             : 'Submit',
  handleSubmitForm       : () => { },
  copyUserProfileOnClick : () => { },
  handleAddressChange    : () => { },
  isAddSeller            : false,
  handleAddSellerOnClick : () => { },
  addSellerButtonText    : 'Add Seller',
  user                   : { },
  user_address           : { },
  seller                 : { }
}

const UserCreateForm = ({
  buttonText,
  handleSubmitForm,
  copyUserProfileOnClick,
  handleAddressChange,
  isAddSeller,
  handleAddSellerOnClick,
  addSellerButtonText,
  user,
  user_address,
  seller
}) => (
  <Formik
    enableReinitialize= { true }
    initialValues={ initialValues(user, user_address, seller) }
    validationSchema={ userCreateFormSchema(isAddSeller) }
    onSubmit={ handleSubmitForm }
  >
    {
      (formikBag) => (
        <Form>
          <Row>
            <Col>
              <Card body>
                <UserFields formikBag={ formikBag } />
              </Card>
            </Col>
            <Col>
              <Card body>
                <AddressFields
                  user_address={ user_address }
                  formikBag={ formikBag }
                  handleAddressChange={ handleAddressChange }
                />
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <LoaderButton
                className='float-right mb-4'
                color='primary'
                onClick={ () => { handleAddSellerOnClick(formikBag) } }
                text={ addSellerButtonText }
              />
            </Col>
          </Row>

          {
            isAddSeller &&
            (
              <>
                <TitlePage mainTitle={ 'Seller' } />
                <Row>
                  <Col>
                    <Card body>
                      <SellerCreateFields
                        formikBag={ formikBag }
                        copyUserProfileOnClick={ copyUserProfileOnClick }
                      />
                    </Card>
                  </Col>
                  <Col>
                    <Card body>
                      <SellerBankAccountFields />
                    </Card>
                  </Col>
                </Row>
              </>
            )
          }

          <Row>
            <Col>
              <LoaderButton
                className='float-right'
                color='primary'
                type='submit'
                onSubmit={ formikBag.submitForm }
                disabled={ formikBag.isSubmitting }
                isLoading={ formikBag.isSubmitting }
                text={ buttonText }
              />
            </Col>
          </Row>
        </Form>
      )
    }
  </Formik>
)

UserCreateForm.propTypes    = propTypes
UserCreateForm.defaultProps = defaultProps

export default UserCreateForm